module.exports = __webpack_public_path__ + "img/344d781.png";